import routes from "../routes";

export const noAuthRoutes = [routes.login.route, routes.onboarding.route];